import { LOGOUT } from 'Redux/reducers/auth';

export const USER_RECOMMENDATIONS_FETCH = 'frontend/user-recommendations/USER_RECOMMENDATIONS_FETCH';
export const USER_RECOMMENDATIONS_LONG_TAIL_FETCH = 'frontend/user-recommendations/USER_RECOMMENDATIONS_LONG_TAIL_FETCH';

export const initialState = {};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case USER_RECOMMENDATIONS_FETCH:
      return {
        ...state,
        recommendations: action.payload,
      };
    case USER_RECOMMENDATIONS_LONG_TAIL_FETCH:
      return {
        ...state,
        ...action.payload,
      };
    // Whatever way the session ends (logout, logout everywhere, account deletion, expiry), the next user must not
    // see this one's recommendations, and the on-demand fetches treat a populated slice as already loaded.
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
}
